import { render } from "./PaneListSamples.vue?vue&type=template&id=4d8c6c86&scoped=true&ts=true"
import script from "./PaneListSamples.vue?vue&type=script&lang=ts"
export * from "./PaneListSamples.vue?vue&type=script&lang=ts"

import "./PaneListSamples.vue?vue&type=style&index=0&id=4d8c6c86&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8c6c86"]])

export default __exports__